import { h, render } from 'preact';
import MobileMenu from './mobile-menu';

export default (element, data) => {
  const promoBar = document.getElementById('promo-bar');
  const headerData = document.getElementById('header-data');
  const init = () => {
    render(
      <MobileMenu
        promoBar={promoBar ? JSON.parse(promoBar.textContent) : {}}
        navigation={
          headerData ? JSON.parse(headerData.textContent).navigation : {}
        }
        {...data}
      />,
      element,
    );
  };

  init();
};
